var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticClass: "ProofDeliveryHistory", attrs: { fluid: "" } },
    [
      _c("PaginationController", {
        ref: "paginate",
        attrs: {
          getDataActionName: "getApiLabels",
          historyLimit: _vm.historyLimit,
          select: _vm.hazmatWarehouseSite,
          haveStartDate: "",
          isStartWithoutData: "",
          startDate: _vm.startDate,
          isApi: true,
          maxDate: _vm.maxDate,
          minDate: _vm.minDate,
          actionPredicates: _vm.generatePredicate
        },
        scopedSlots: _vm._u([
          {
            key: "afterDate",
            fn: function() {
              return [
                _c(
                  "v-flex",
                  [
                    _c(
                      "v-layout",
                      { attrs: { "align-center": "", "justify-end": "" } },
                      [
                        _c(
                          "v-flex",
                          { attrs: { xs5: "" } },
                          [
                            _c("v-switch", {
                              attrs: { label: _vm.isMergePDF ? "PDF" : "ZIP" },
                              model: {
                                value: _vm.isMergePDF,
                                callback: function($$v) {
                                  _vm.isMergePDF = $$v
                                },
                                expression: "isMergePDF"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-flex",
                          { attrs: { xs6: "" } },
                          [
                            _c("LoaderButton", {
                              attrs: {
                                isSmall: "",
                                buttonText: _vm.$t("downloadLabelsNum", {
                                  selectedLabelsLength:
                                    _vm.selectedLabels.length
                                }),
                                promiseAwait: _vm.downloadSelectedLabelAndZip,
                                disabled: _vm.selectedLabels.length === 0
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-flex",
                          { attrs: { "justify-end": "" } },
                          [
                            _c(
                              "v-btn",
                              {
                                attrs: {
                                  small: "",
                                  color: "primary",
                                  loading: _vm.exportLabelsPopup.loading
                                },
                                on: { click: _vm.showExportLabelsPopup }
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.$t("exportLabels")) +
                                    "\n            "
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-flex",
                          { attrs: { "justify-end": "" } },
                          [
                            _c(
                              "v-btn",
                              {
                                attrs: {
                                  small: "",
                                  color: "primary",
                                  disabled: _vm.selectedLabels.length === 0
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.exportLabelsToExcel({
                                      labels: _vm.selectedLabels
                                    })
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.$t("exportSelectedLabels")) +
                                    "(" +
                                    _vm._s(_vm.selectedLabels.length) +
                                    ")\n              "
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            },
            proxy: true
          },
          {
            key: "beforeMenu",
            fn: function() {
              return [
                _c(
                  "v-layout",
                  { attrs: { "justify-start": "" } },
                  [
                    _c(
                      "v-flex",
                      { attrs: { xs3: "", "mr-1": "" } },
                      [
                        _c("v-select", {
                          attrs: {
                            items: [
                              { name: _vm.$t("status"), value: "status" },
                              {
                                name: _vm.$t("requestId"),
                                value: "requestIds"
                              },
                              { name: _vm.$t("tracking"), value: "trackings" }
                            ],
                            "item-value": "value",
                            "item-text": "name",
                            label: _vm.$t("searchMode")
                          },
                          on: {
                            change: function(e) {
                              _vm.searchText = ""
                              _vm.requestId = ""
                              _vm.selectText = ""
                              _vm.searchTracking = ""
                            }
                          },
                          model: {
                            value: _vm.searchMode,
                            callback: function($$v) {
                              _vm.searchMode = $$v
                            },
                            expression: "searchMode"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.searchMode === "requestIds"
                      ? _c(
                          "v-flex",
                          { attrs: { xs4: "", "pl-3": "" } },
                          [
                            _c("v-text-field", {
                              attrs: {
                                label: "" + _vm.$t("requestId"),
                                hint:
                                  _vm.$t("requestId") +
                                  " **" +
                                  _vm.$t("enterToNext"),
                                clearable: ""
                              },
                              on: {
                                change: function($event) {
                                  return _vm.changeBatchSearch(
                                    _vm.requestId,
                                    "requestIds"
                                  )
                                }
                              },
                              model: {
                                value: _vm.requestId,
                                callback: function($$v) {
                                  _vm.requestId = $$v
                                },
                                expression: "requestId"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.searchMode === "trackings"
                      ? _c(
                          "v-flex",
                          { attrs: { xs4: "", "pl-3": "" } },
                          [
                            _c("v-text-field", {
                              attrs: {
                                label: "" + _vm.$t("tracking"),
                                hint:
                                  _vm.$t("trackingNumber") +
                                  " **" +
                                  _vm.$t("enterToNext"),
                                clearable: ""
                              },
                              on: {
                                change: function($event) {
                                  return _vm.changeBatchSearch(
                                    _vm.searchTracking,
                                    "searchTrackings"
                                  )
                                }
                              },
                              model: {
                                value: _vm.searchTracking,
                                callback: function($$v) {
                                  _vm.searchTracking = $$v
                                },
                                expression: "searchTracking"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.searchMode === "status"
                      ? [
                          _c(
                            "v-flex",
                            { attrs: { xs2: "" } },
                            [
                              _c("v-autocomplete", {
                                attrs: {
                                  items: _vm.labelStatusArray,
                                  "item-value": "value",
                                  "item-text": "name",
                                  label: _vm.$t("labelStatus")
                                },
                                model: {
                                  value: _vm.selectText,
                                  callback: function($$v) {
                                    _vm.selectText = $$v
                                  },
                                  expression: "selectText"
                                }
                              })
                            ],
                            1
                          )
                        ]
                      : _vm._e()
                  ],
                  2
                )
              ]
            },
            proxy: true
          },
          {
            key: "dataTable",
            fn: function() {
              return [
                _c("v-data-table", {
                  attrs: {
                    headers: _vm.headers,
                    items: _vm.labels,
                    "hide-actions": "",
                    "item-key": "orderId"
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "items",
                      fn: function(props) {
                        return [
                          _c(
                            "td",
                            {
                              staticClass: "checkbox-align-center",
                              on: {
                                click: function($event) {
                                  props.item.url &&
                                    props.item.status !== "canceled" &&
                                    (props.selected = !props.selected)
                                }
                              }
                            },
                            [
                              _c(
                                "v-layout",
                                [
                                  _c("v-checkbox", {
                                    attrs: {
                                      disabled:
                                        !props.item.url ||
                                        props.item.status === "canceled",
                                      value: props.selected,
                                      primary: "",
                                      "hide-details": ""
                                    },
                                    on: {
                                      click: function($event) {
                                        $event.stopPropagation()
                                        return function() {
                                          props.selected = !props.selected
                                        }.apply(null, arguments)
                                      }
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "td",
                            { staticClass: "text-xs-left" },
                            [
                              _c("LabelDetailsWidget", {
                                attrs: {
                                  shipmentLabel: props.item,
                                  index: props.index
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "td",
                            { staticClass: "text-xs-left" },
                            [
                              _c("LabelAddressWidget", {
                                attrs: { address: props.item.from }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "td",
                            { staticClass: "text-xs-left" },
                            [
                              _c("LabelAddressWidget", {
                                attrs: { address: props.item.to }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.$store.getters.activeWarehouse
                            ? _c("td", { staticClass: "text-xs-left" }, [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(
                                      _vm.organizationKeyToId.get(
                                        props.item.clientKey
                                      )
                                    ) +
                                    "\n                "
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "td",
                            { staticClass: "text-xs-left" },
                            [
                              _c("v-layout", [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(
                                      _vm.toDateYYYYMMDD(
                                        new Date(props.item.createTime)
                                      )
                                    ) +
                                    "\n                  "
                                )
                              ]),
                              _vm._v(" "),
                              _c("v-layout", [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(props.item.shipDate) +
                                    "\n                  "
                                )
                              ]),
                              _vm._v(" "),
                              props.item.estimatedDelivery &&
                              props.item.estimatedDelivery !== "N/A"
                                ? _c(
                                    "v-layout",
                                    { staticClass: "text-capitalize" },
                                    [
                                      typeof props.item.estimatedDelivery ===
                                      "string"
                                        ? _c("v-flex", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.toDateYYYYMMDD(
                                                  new Date(
                                                    props.item.estimatedDelivery
                                                  )
                                                )
                                              )
                                            )
                                          ])
                                        : _c("v-flex", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.toDateYYYYMMDD(
                                                  new Date(
                                                    props.item.estimatedDelivery
                                                  )
                                                )
                                              )
                                            )
                                          ])
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "td",
                            { staticClass: "text-xs-left" },
                            [
                              props.item.status !== "failed"
                                ? _c("LabelTrackingDetailWidget", {
                                    attrs: {
                                      trackingNumber: props.item.trackingNumber,
                                      status: props.item.status,
                                      carrier: props.item.carrier,
                                      details: props.item.trackingDetails,
                                      isServer: true,
                                      trackStatus: props.item.trackStatus,
                                      trackDescription:
                                        props.item.trackDescription
                                    }
                                  })
                                : props.item.messages
                                ? _c(
                                    "div",
                                    _vm._l(props.item.messages, function(
                                      messageItem
                                    ) {
                                      return _c(
                                        "p",
                                        { key: messageItem.time },
                                        [
                                          _vm._v(
                                            "\n                      " +
                                              _vm._s(messageItem.message) +
                                              "\n                    "
                                          )
                                        ]
                                      )
                                    }),
                                    0
                                  )
                                : _vm._e()
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "td",
                            { staticClass: "text-xs-left" },
                            [
                              props.item.carrier
                                ? _c("v-layout", [
                                    _c("strong", [
                                      _vm._v(_vm._s(props.item.carrier))
                                    ])
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _c("v-layout", [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(props.item.serviceDescription) +
                                    "\n                  "
                                )
                              ])
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "td",
                            {
                              class: props.item.totalAmount
                                ? "text-xs-left fontRed"
                                : props.item.amount > 0
                                ? "text-xs-left fontGreen"
                                : "text-xs-left fontRed"
                            },
                            [
                              _vm._v(
                                "\n                  $" +
                                  _vm._s(
                                    -props.item.totalAmount ||
                                      props.item.amount ||
                                      0
                                  ) +
                                  "\n                "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("td", { staticClass: "text-xs-left" }, [
                            _c(
                              "span",
                              {
                                style: {
                                  backgroundColor: _vm.isLabelOverOneWeek(
                                    props.item
                                  )
                                    ? "yellow"
                                    : ""
                                }
                              },
                              [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(_vm.getStatusText(props.item)) +
                                    "\n                  "
                                )
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "td",
                            { staticClass: "text-xs-center" },
                            [
                              _c(
                                "v-layout",
                                { attrs: { row: "", "justify-center": "" } },
                                [
                                  props.item.url
                                    ? _c(
                                        "span",
                                        [
                                          _c(
                                            "v-tooltip",
                                            {
                                              attrs: { top: "" },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "activator",
                                                    fn: function(tooltip) {
                                                      return [
                                                        _c(
                                                          "div",
                                                          _vm._g(
                                                            {},
                                                            tooltip.on
                                                          ),
                                                          [
                                                            _c(
                                                              "v-btn",
                                                              {
                                                                attrs: {
                                                                  flat: "",
                                                                  icon: "",
                                                                  color: props
                                                                    .item
                                                                    .isDownloaded
                                                                    ? "success"
                                                                    : "primary",
                                                                  disabled:
                                                                    !props.item
                                                                      .url ||
                                                                    [
                                                                      "canceled",
                                                                      "failed"
                                                                    ].includes(
                                                                      props.item
                                                                        .status
                                                                    )
                                                                },
                                                                on: {
                                                                  click: function(
                                                                    $event
                                                                  ) {
                                                                    $event.stopPropagation()
                                                                    return _vm.downloadFile(
                                                                      props.item
                                                                        .url,
                                                                      props.item
                                                                        .orderKey,
                                                                      props.item
                                                                        ._key
                                                                    )
                                                                  }
                                                                }
                                                              },
                                                              [
                                                                _c("v-icon", [
                                                                  _vm._v(
                                                                    "preview"
                                                                  )
                                                                ])
                                                              ],
                                                              1
                                                            )
                                                          ],
                                                          1
                                                        )
                                                      ]
                                                    }
                                                  }
                                                ],
                                                null,
                                                true
                                              )
                                            },
                                            [
                                              _vm._v(
                                                "\n                        " +
                                                  _vm._s(_vm.$t("openLabel")) +
                                                  "\n                      "
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    [
                                      _c(
                                        "v-menu",
                                        {
                                          attrs: { "offset-y": "" },
                                          scopedSlots: _vm._u(
                                            [
                                              props.item.carrier !== "USPS" &&
                                              (props.item.status ===
                                                "created" ||
                                                props.item.status === "pending")
                                                ? {
                                                    key: "activator",
                                                    fn: function(ref) {
                                                      var on = ref.on
                                                      return [
                                                        _c(
                                                          "v-tooltip",
                                                          {
                                                            attrs: { top: "" },
                                                            scopedSlots: _vm._u(
                                                              [
                                                                {
                                                                  key:
                                                                    "activator",
                                                                  fn: function(
                                                                    tooltip
                                                                  ) {
                                                                    return [
                                                                      _c(
                                                                        "div",
                                                                        _vm._g(
                                                                          {},
                                                                          tooltip.on
                                                                        ),
                                                                        [
                                                                          _c(
                                                                            "v-btn",
                                                                            {
                                                                              attrs: {
                                                                                dark:
                                                                                  "",
                                                                                icon:
                                                                                  "",
                                                                                flat:
                                                                                  "",
                                                                                color:
                                                                                  "primary"
                                                                              },
                                                                              on: {
                                                                                click: function(
                                                                                  $event
                                                                                ) {
                                                                                  $event.stopPropagation()
                                                                                  return on.click.apply(
                                                                                    null,
                                                                                    arguments
                                                                                  )
                                                                                }
                                                                              }
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "v-icon",
                                                                                [
                                                                                  _vm._v(
                                                                                    "build"
                                                                                  )
                                                                                ]
                                                                              )
                                                                            ],
                                                                            1
                                                                          )
                                                                        ],
                                                                        1
                                                                      )
                                                                    ]
                                                                  }
                                                                }
                                                              ],
                                                              null,
                                                              true
                                                            )
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                            " +
                                                                _vm._s(
                                                                  _vm.$t("more")
                                                                ) +
                                                                "\n                          "
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    }
                                                  }
                                                : null
                                            ],
                                            null,
                                            true
                                          )
                                        },
                                        [
                                          _vm._v(" "),
                                          _c(
                                            "v-list",
                                            [
                                              _c(
                                                "v-list-tile",
                                                {
                                                  staticClass:
                                                    "list-tile-center"
                                                },
                                                [
                                                  _c(
                                                    "v-tooltip",
                                                    {
                                                      attrs: { top: "" },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "activator",
                                                            fn: function(
                                                              tooltip
                                                            ) {
                                                              return [
                                                                _c(
                                                                  "div",
                                                                  _vm._g(
                                                                    {},
                                                                    tooltip.on
                                                                  ),
                                                                  [
                                                                    _c(
                                                                      "LoaderButton",
                                                                      {
                                                                        attrs: {
                                                                          flat:
                                                                            "",
                                                                          buttonText: _vm.$t(
                                                                            "cancel"
                                                                          ),
                                                                          promiseAwait:
                                                                            _vm.cancelLabel,
                                                                          disabled:
                                                                            _vm.visibleBetaFeatures.includes(
                                                                              "cancelLabelByDownloaded"
                                                                            ) &&
                                                                            props
                                                                              .item
                                                                              .isDownloaded,
                                                                          promiseItem:
                                                                            props.item
                                                                        }
                                                                      }
                                                                    )
                                                                  ],
                                                                  1
                                                                )
                                                              ]
                                                            }
                                                          }
                                                        ],
                                                        null,
                                                        true
                                                      )
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                              " +
                                                          _vm._s(
                                                            props.item
                                                              .isDownloaded
                                                              ? _vm.$t(
                                                                  "contactToCancelLabel"
                                                                )
                                                              : _vm.$t("cancel")
                                                          ) +
                                                          "\n                            "
                                                      )
                                                    ]
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ]
                      }
                    }
                  ]),
                  model: {
                    value: _vm.selectedLabels,
                    callback: function($$v) {
                      _vm.selectedLabels = $$v
                    },
                    expression: "selectedLabels"
                  }
                })
              ]
            },
            proxy: true
          }
        ]),
        model: {
          value: _vm.labels,
          callback: function($$v) {
            _vm.labels = $$v
          },
          expression: "labels"
        }
      }),
      _vm._v(" "),
      _c("FormSubmitPopup", {
        attrs: {
          title: _vm.$t("exportLabels"),
          rightMethod: _vm.exportLabels,
          rightButtonText: _vm.$t("export"),
          small: "",
          hasAlert: ""
        },
        on: {
          popupClose: function($event) {
            _vm.exportLabelsPopup.show = false
          }
        },
        scopedSlots: _vm._u([
          {
            key: "input",
            fn: function() {
              return [
                _c(
                  "v-layout",
                  [
                    _c(
                      "v-flex",
                      [
                        _c("DatePicker", {
                          attrs: {
                            label: _vm.$t("date"),
                            range: "",
                            max: _vm.dateMax,
                            min: _vm.dateMin
                          },
                          model: {
                            value: _vm.exportLabelsPopup.dates,
                            callback: function($$v) {
                              _vm.$set(_vm.exportLabelsPopup, "dates", $$v)
                            },
                            expression: "exportLabelsPopup.dates"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            },
            proxy: true
          }
        ]),
        model: {
          value: _vm.exportLabelsPopup.show,
          callback: function($$v) {
            _vm.$set(_vm.exportLabelsPopup, "show", $$v)
          },
          expression: "exportLabelsPopup.show"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-88f32fac", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-88f32fac","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ApiLabel.vue
// module id = null
// module chunks = 